import { render, staticRenderFns } from "./PdvCloseCheckout.vue?vue&type=template&id=ca6c4bf8&"
import script from "./PdvCloseCheckout.vue?vue&type=script&lang=js&"
export * from "./PdvCloseCheckout.vue?vue&type=script&lang=js&"
import style0 from "./PdvCloseCheckout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports